
<div class="min-h-screen flex flex-column surface-ground">

  <nav-bar style="z-index: 1000"></nav-bar>
<!--   <test-env-footer></test-env-footer>
 -->
  <router-outlet style="z-index: 500"></router-outlet>

  </div>
